import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Logger from '@/helpers/logger'
import DashboardLogger from '@/helpers/dashboard-logger'
import Auth from '@/helpers/auth'
import Feedback from '@/helpers/feedback'
import VueClipboard from 'vue-clipboard2'
import VueCodeMirror from 'vue-codemirror'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'
import gapiConfig from './gapi.config'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import iView from 'view-design'
import locale from 'view-design/dist/locale/en-US'
import VueCountdownTimer from 'vuejs-countdown-timer'
import VueGAPI from '@/helpers/vue-gapi.min'
import 'view-design/dist/styles/iview.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/mode/sql/sql'
import 'codemirror/mode/python/python'
import 'codemirror/addon/display/autorefresh'
import './styles/custom.less'
import './styles/colors.css'
import './styles/icons.css'
import './styles/markdown.css'
import './styles/forum.css'

Vue.use(iView, { locale })
Vue.use(VueClipboard)
Vue.use(VueCodeMirror)
Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_ATTR: ['target']
  }
})
Vue.use(require('vue-moment'))
Vue.use(VueGAPI, gapiConfig)
Vue.use(VueCountdownTimer)

Vue.use(Logger)
Vue.use(DashboardLogger)
Vue.use(Auth)
Vue.use(Feedback)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries: ['places', 'drawing', 'visualization'], // This is required if you use the Autocomplete plugin
    v: '3.38' // Version to be used
  }
})

Vue.config.productionTip = false

axios.interceptors.request.use(function (config) {
  // send cookie by default
  const isLogoutReq = (config.url || '').startsWith(`${process.env.VUE_APP_API_URI}/auth/logout`)

  if (Vue.prototype.$auth.getIdToken() || isLogoutReq) {
    config.withCredentials = !(config.url || '').includes('https://lime-data-portal')
    return config
  }

  return {}
}, function (error: Error) {
  // Do something with request error
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // logout if server determines cookie is missing / expired
  if (error.response && error.response.status === 401) {
    // modeled after App.vue's logout function
    Vue.prototype.$auth.setId(null)
    Vue.prototype.$auth.logout()
    router.push('/login')
  }
  return Promise.reject(error)
})

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://1b5afb36bd734567861a909ef3b3c254@sentry.io/1770728',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

// @ts-ignore
export default new Vue({
  store,
  router,
  components: { App },
  data: { preferences: JSON.parse(localStorage.getItem('preferences') || '{}') },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')
